module.exports = __webpack_public_path__ + "img/wan6.d31a3bea.png";